export default __webpack_public_path__ + "static/media/kitchen.7fd52b04.jpg";